module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-progress/~/babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 1546
// module chunks = 0